export enum DayFilter {
   AllDays,
   WeekDays,
   WeekendDays
}